// extracted by mini-css-extract-plugin
export default {"FolderPopupButtons":"FolderPopupButtons_FolderPopupButtons__OK7ZF","swing-in":"FolderPopupButtons_swing-in__8ISk1"};